<script lang="ts">
	//Design system components
	import { Button, ButtonGroup, Container, Radio, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { real_id } from 'src/helpers/interface_helpers';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { devices } from 'src/stores/lists/devices';
	import { format } from 'svelte-i18n';

	export let device;

	let loading = false;

	let otherChannelId = device.id.indexOf('_') > -1 ? real_id(device.id) : device.id + '_1';

	let otherChannelName = $devices[otherChannelId].name;
	let otherChannelIndex = device.id.indexOf('_') > -1 ? 0 : 1;

	const setCalibration = async () => {
		loading = true;
		const res = await gen2Request(device, `em1.CalibrateFrom`, {
			id: device.channel,
			other_id: otherChannelIndex,
		});
		await onSettingsResponse(res, device, { danger: res?.errors?.message });
		loading = false;
	};
</script>

<Text class="mb-m" styleType="body-small"
	>{$format('calibrate_channel_from_channel_2_channels_description', {
		default: `Calibrate this channel ("${device.channel}") from the known good one: ("${otherChannelIndex}") named "${otherChannelName}". Please connect this channel on the same line as the other. A minimum load is required for successful channel to  channel calibration.`,
		values: {
			deviceChannel: device.channel,
			otherChannelIndex,
			otherChannelName,
		},
	})}</Text
>

<Button size="m" {loading} width="full" on:click={setCalibration}>{$format('button_calibrate')}</Button>
